export default function toString(x) {
  return x == null ? void 0 : x.toString();
}